import React, { FunctionComponent } from "react";
import "./index.scss";

type ProcessingPaymentProps = {};

export const ProcessingPayment: FunctionComponent<ProcessingPaymentProps> = () => 
  <div className="processing active">
    <div className="processing-inner">
      <strong>Processing payment</strong>Please don't refresh your browser.
    </div>
  </div>
